import React from 'react';
import { Section } from './ui/Section';
export function Guarantee() {
  return <Section data-id="element-103">
      <div className="bg-neutral-900 border border-neutral-800 rounded-3xl p-8 md:p-12 text-center max-w-3xl mx-auto relative overflow-hidden" data-id="element-104">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-accent to-transparent opacity-50" data-id="element-105"></div>

        <div className="text-5xl mb-6" data-id="element-106">🛡️</div>
        <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-107">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <p className="text-xl text-neutral-300 mb-6" data-id="element-108">
          Abrís los tomos. Aplicáis el sistema.
        </p>

        <p className="text-xl text-neutral-300 mb-6" data-id="element-109">
          Si en 7 días no es exactamente lo que esperabas:
        </p>

        <div className="inline-block bg-brand-accent text-white font-black text-2xl md:text-3xl px-6 py-3 rounded-xl mb-6 transform -rotate-1" data-id="element-110">
          devolución del 100%
        </div>

        <p className="text-xl text-neutral-300 mb-8" data-id="element-111">
          sin formularios, sin drama, sin explicaciones.
        </p>

        <div className="text-sm text-neutral-500 font-medium uppercase tracking-widest" data-id="element-112">
          Tasa de devoluciones: menos del 1%.
        </div>
      </div>
    </Section>;
}